import dayjs from 'dayjs';
import { useStoreState } from 'easy-peasy';
import { PropTypes } from 'prop-types';
import React, { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';

import { CheckedState } from '@ge/components/checkbox';
import { DateTimeFormats, TaskTemplateModes } from '@ge/models/constants';

import { useServiceGroups } from '../../../../../features/manage/util/worker-util';
import { SelectMetaField } from '../../meta-fields';

const StyledSelect = styled(SelectMetaField)`
  .select__menu {
    .select__menu-list {
      max-height: 62px;
      &::-webkit-scrollbar {
        width: 4px;
        height: 0px;
      }
      &::-webkit-scrollbar-track {
        background: ${(props) => props.theme.scrollbar.trackBackground};
      }
      &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.scrollbar.thumbBackground};
        border-radius: 2.5px;
      }
    }
  }
`;

export const AssigneeSelect = ({
  defaultValue,
  metadata,
  task,
  templateMode,
  disabled,
  multiDayDate,
  index,
  name,
  label,
}) => {
  const { t } = useTranslation(['tasks'], { useSuspense: false });
  const [selectedCrew, setDefaultCrew] = useState(defaultValue);

  const { watch } = useFormContext();
  const watchScheduleDate = watch('scheduleDate');
  const watchMultiDay = watch('multiDay');
  const isMultiDay = watchMultiDay === CheckedState.CHECKED ? true : false;

  const { crewsSg } = useStoreState((state) => state.workers);

  const serviceGroups = useServiceGroups();
  const { serviceGroupId: selectedServiceGroupId } = useParams();

  const assigneeSelectOptions = useMemo(() => {
    if (watchScheduleDate || multiDayDate) {
      const scheduleDate = isMultiDay
        ? dayjs(multiDayDate).format(DateTimeFormats.ENDPOINT_PARAM)
        : dayjs(watchScheduleDate).format(DateTimeFormats.ENDPOINT_PARAM);

      const taskScheduledDate = task?.scheduleDateTz
        ? dayjs(task?.scheduleDateTz).format(DateTimeFormats.CREW_TIMING)
        : null;
      if (!isMultiDay && scheduleDate !== taskScheduledDate) {
        setDefaultCrew(null);
      }
      return crewsSg
        ?.map(
          (crew) =>
            (watchScheduleDate || multiDayDate) &&
            scheduleDate &&
            dayjs(scheduleDate).isBetween(
              dayjs(crew.crewStartDate),
              dayjs(crew.crewEndDate),
              null,
              '[]',
            ) && {
              value: crew?._id,
              label: crew?.name,
            },
        )
        .filter((crew) => crew);
    } else {
      return [];
    }
  }, [watchScheduleDate, multiDayDate, isMultiDay, task?.scheduleDateTz, crewsSg]);

  const assignedCrew = assigneeSelectOptions.find((val) => val.value === selectedCrew);

  return (
    <div>
      <StyledSelect
        defaultValue={selectedCrew}
        //name="assignee"
        name={name || (isMultiDay ? `schedule[${index}].crewIds` : 'assignee')}
        label={label ? label : t('form.assignee', 'Crew Assignment')}
        metadata={metadata}
        minWidth={150}
        options={
          templateMode === TaskTemplateModes.CREATE || TaskTemplateModes.EDIT
            ? selectedServiceGroupId || serviceGroups.length === 1
              ? assigneeSelectOptions
              : []
            : assigneeSelectOptions
        }
        placeholder={
          !selectedServiceGroupId && assigneeSelectOptions.length > 1
            ? assignedCrew?.label
            : t('form.unassigned', 'Unassigned')
        }
        // disabled={
        //   selectedServiceGroupId
        //     ? disabled || !selectedServiceGroupId
        //     : serviceGroups.length > 1 || disabled
        // }
      />
    </div>
  );
};

AssigneeSelect.propTypes = {
  metadata: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  task: PropTypes.object.isRequired,
  templateMode: PropTypes.oneOf(Object.values(TaskTemplateModes)).isRequired,
  disabled: PropTypes.bool,
  multiDayDate: PropTypes.object,
  index: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
};
